import React, { FC, useState, ChangeEvent, useContext } from "react";
import Col from "antd/lib/col";
import Message from "antd/lib/message";
import moment from "moment";
import { TypeNote, TypeNoteValidation } from "../../types/TypeContact";
import { addNoteAction } from "./actions";
import { NoteHistoryContext } from "../../contexts/noteHistory";
import { ReactComponent as TrashIcon } from "../../icons/trash.svg";
import {
  StyledButton,
  StyledInput,
  StyledContent,
  StyledLayout,
  StyledSpace,
  StyledRow,
  StyledTextArea,
} from "./styledComponents";
import { CallerInforContext } from "../../contexts/customerProfile";

const AddNote: FC = () => {
  const { callerInfor } = useContext(CallerInforContext);
  const { updateNoteHistoryList } = useContext(NoteHistoryContext);
  const [note, setNote] = useState<TypeNote>({ subject: "", note: "" });
  const [processing, setProcessing] = useState<boolean>(false);
  const [validationResults, setValidationResults] = useState<
    TypeNoteValidation
  >({
    subject: { validated: false, showError: false },
    note: { validated: false, showError: false },
  });

  const onChange = (type: string) => (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const value = e.target.value;
    note[type] = value;
    // validation
    const vResult = value.trim().length > 0;
    validationResults[type] = { validated: vResult, showError: !vResult };
    setNote({ ...note });
    setValidationResults({ ...validationResults });
  };

  const resetNote = () => {
    setNote({
      subject: "",
      note: "",
    });
    setValidationResults({
      subject: { validated: false, showError: false },
      note: { validated: false, showError: false },
    });
  };

  const addNote = async () => {
    if (Object.values(validationResults).some((x) => !x.validated)) {
      Object.keys(validationResults).forEach((k) => {
        validationResults[k].showError = !validationResults[k].validated;
      });
      setValidationResults({ ...validationResults });
    } else {
      setProcessing(true);
      const newNote = JSON.stringify(note);
      const urlParams = new URL(window.location.href).searchParams;
      const aName = urlParams.get("agentName")!;
      const queueName = urlParams.get("queueName") || "N/A";
      const eType = urlParams.get("endpointType") || "N/A";
      const newNoteObject = {
        phoneNumber: callerInfor.phoneNumber,
        timestamp: moment().format(),
        contactNotes: newNote,
        agentName: aName,
        queueName: queueName,
        endpointType: eType,
      };
      const result = await addNoteAction(newNoteObject, callerInfor);
      if (result === 200) {
        resetNote();
        Message.success("Add note successful.", 1);
        updateNoteHistoryList([newNoteObject]);
      } else {
        Message.error("Add note failed.", 1);
      }
      setProcessing(false);
    }
  };

  return (
    <StyledLayout>
      <StyledContent>
        <div>
          <StyledInput
            placeholder="Add a subject"
            value={note.subject}
            onChange={onChange("subject")}
            error={
              !validationResults.subject.validated &&
              validationResults.subject.showError
            }
          />
          {!validationResults.subject.validated &&
          validationResults.subject.showError ? (
            <p>Subject is required</p>
          ) : null}
        </div>
        <div>
          <StyledTextArea
            value={note.note}
            onChange={onChange("note")}
            error={
              !validationResults.note.validated &&
              validationResults.note.showError
            }
          />
          {!validationResults.note.validated &&
          validationResults.note.showError ? (
            <p>Note description is required</p>
          ) : null}
        </div>
        <StyledSpace />
        <StyledRow>
          <Col style={{ paddingTop: "11px" }} span={12}>
            <TrashIcon style={{ fontSize: "18px" }} onClick={resetNote} />
          </Col>
          <Col span={12} style={{ textAlign: "right", paddingTop: "5px" }}>
            <StyledButton onClick={addNote} loading={processing}>
              Add note
            </StyledButton>
          </Col>
        </StyledRow>
      </StyledContent>
    </StyledLayout>
  );
};

export default AddNote;
